import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {FisoMathProvider} from '../../providers/fiso-math/fiso-math';
import {NavParams} from "ionic-angular";

export const FLASH_CARD_TYPE = {
    FINGER: 'finger',
    SOROBAN: 'soroban'
};

/**
 * Generated class for the FlashCardContainerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'flash-card-container',
    templateUrl: 'flash-card-container.html',
    providers: [FisoMathProvider]
})
export class FlashCardContainerComponent implements OnInit {
    config: any = {
        disabled: {
            number_of_numbers: false,
            timers: false,
            number_of_questions: false,
            delay_timers: false,
        },
        numbers: [1, 2],
        number_of_numbers: '2',
        timers: '6',
        current_questions: 1,
        number_of_questions: '20',
        answer_timers: '10'
    };

    @Input() level = null;
    @Input() sub_level = null;
    @Input() board_name = null;

    isShowSummary = false;

    log_group = null;

    @Input() type = 'finger';
    @Input() options: any = {};

    currentNumber: any = '';
    myAnswer: any = '';
    timeoutShowResultSignForText: any = null;
    timeoutAnswer: any = null;

    isGaming = false;
    isTry = false;
    isShowResultSignForText = false;

    isShowFullAnswer = false;
    isSuccess = false;
    isFail = false;
    isBravo = false;
    isReStart = false;

    constructor(public fisoMathProvider: FisoMathProvider,
                public navParams: NavParams) {
        console.log('Hello FlashCardContainerComponent Component');
    }

    ngOnInit() {
        this.config = {...this.config, ...this.options};
        this.getRoom();
    }

    public room: any = null;
    public user_id: any = null;
    public fight_rounds = [];

    getRoom() {
        this.user_id = window.localStorage.getItem('USER_ID');
        this.user_id = parseInt(this.user_id);

        this.room = this.navParams.get('room');
        if (this.room) {
            this.room.author_post_id = parseInt(this.room.author_post_id);
        }
    }

    try() {
        this.isTry = true;
        this.isGaming = true;

        this.currentNumber = this.generateNumbers();

        setTimeout(() => {
            document.getElementById('flash_container_main_controls_left_answer').focus();
        }, 400);

        this.timeoutShowResultSignForText = setTimeout(() => {
            this.isShowResultSignForText = true;

            this.timeoutAnswer = setTimeout(() => {
                this.submitTry();

            }, this.config.answer_timers * 1000);
        }, this.config.timers * 1000);
    }

    start() {
        if (this.room) {
            for (let i = 0; i < this.config.number_of_questions; i ++) {
                this.fight_rounds.push(this.generateNumbers());
            }
        }

        this.config.current_questions = 1;
        this.log_group = this.fisoMathProvider.guid();
        this.isReStart = false;

        // setup try and start
        this.isTry = false;
        this.isGaming = true;

        this.startRound();
    }

    private startRound() {
        this.isShowResultSignForText = false;

        // parse data
        this.config.timers = parseInt(this.config.timers);
        this.config.answer_timers = parseInt(this.config.answer_timers);
        this.config.current_questions = parseInt(this.config.current_questions);
        this.config.number_of_questions = parseInt(this.config.number_of_questions);


        this.currentNumber = this.generateNumbers();

        setTimeout(() => {
            document.getElementById('flash_container_main_controls_left_answer').focus();
        }, 400);

        this.timeoutShowResultSignForText = setTimeout(() => {
            this.isShowResultSignForText = true;

            this.timeoutAnswer = setTimeout(() => {
                this.submit();

            }, this.config.answer_timers * 1000);

        }, this.config.timers * 1000);
    }

    submit() {
        if (this.isTry) {
            this.submitTry();
            return;
        }

        if (this.timeoutShowResultSignForText) {
            clearTimeout(this.timeoutShowResultSignForText);
        }

        if (this.timeoutAnswer) {
            clearTimeout(this.timeoutAnswer);
        }

        this.isShowResultSignForText = false;
        this.myAnswer = parseInt(this.myAnswer);
        this.currentNumber = parseInt(this.currentNumber);

        this.logPost();

        if (this.myAnswer === this.currentNumber) {
            this.success();
        } else {
            this.failed();
        }

        this.resetNumbers();

        if (this.config.current_questions < this.config.number_of_questions) {
            this.config.current_questions++;
            this.startRound();
        } else {
            this.bravo();
            this.isGaming = false;
            this.isTry = false;
        }
    }

    logPost() {
        this.fisoMathProvider.log({
            'log_group': this.log_group,
            'user_id': window.localStorage.getItem("USER_ID"),
            'level': this.level,
            'sub_level': this.sub_level,
            'board_name': this.board_name,
            'questions': this.currentNumber,
            'answer': this.currentNumber,
            'user_answer': this.myAnswer,
            'is_correct': (this.myAnswer === this.currentNumber) ? 1 : 0,
            'game_config': JSON.stringify(this.config),
            'number_of_questions': this.config.number_of_questions,
            'current_questions': this.config.current_questions,
            'author_id': 0,
        }).subscribe(resp => {
            console.log(resp);
        })
    }

    submitTry() {
        this.isGaming = false;
        this.isTry = false;
        this.isShowResultSignForText = false;

        if (this.timeoutShowResultSignForText) {
            clearTimeout(this.timeoutShowResultSignForText);
        }

        if (this.timeoutAnswer) {
            clearTimeout(this.timeoutAnswer);
        }

        this.myAnswer = parseInt(this.myAnswer);
        this.currentNumber = parseInt(this.currentNumber);

        if (this.myAnswer === this.currentNumber) {
            this.success();
        } else {
            this.failed();
        }

        this.resetNumbers();
    }

    resetNumbers() {
        this.currentNumber = '';
        this.myAnswer = '';
    }

    generateNumbers() {
        let min = 1;
        let max = 99;

        switch (this.type) {
            case FLASH_CARD_TYPE.FINGER:
                min = this.config.number_of_numbers === '1' ? 1 : 10;
                max = 99;
                break;
            case FLASH_CARD_TYPE.SOROBAN:
                min = 1;
                max = 9;
                for (let i = 0; i < (this.config.number_of_numbers - 1); i++) {
                    min = min * 10;
                    max = max * 10 + 9;
                }
                break;
        }

        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
    }

    generateCurrentImage() {
        let html = ``;
        switch (this.type) {
            case FLASH_CARD_TYPE.FINGER:
                html = `<img class="is-finger"
                        src="assets/imgs/fingers/${this.currentNumber}.jpg" />`;
                break;
            case FLASH_CARD_TYPE.SOROBAN:
                const sorobans = (this.currentNumber + '').split('');
                _.forEach(sorobans, (o, k) => {
                    html += `<img class="is-soroban"
                        src="assets/imgs/soroban/${o}${k === (sorobans.length - 1) ? '_end' : ''}.jpg" />`;
                });
                break;
        }

        return html;
    }

    success() {
        const audio = new Audio('assets/sounds/success.mp3');
        audio.play();

        this.isSuccess = true;
        setTimeout(() => {
            this.isSuccess = false;
        }, 2000);
    }

    failed() {
        const audio = new Audio('assets/sounds/fail.mp3');
        audio.play();

        this.isFail = true;
        setTimeout(() => {
            this.isFail = false;
        }, 2000);
    }

    bravo() {
        const audio = new Audio('assets/sounds/bravo.mp3');
        audio.play();

        this.isBravo = true;
        this.isReStart = true;

        setTimeout(() => {
            this.isBravo = false;
        }, 4000);
    }

}



// WEBPACK FOOTER //
// ./src/components/flash-card-container/flash-card-container.ts